import ActionHelper from '@module/redux-actions';

export const actions = ActionHelper.types(['PENDING_SET', 'PENDING_RESET']);

export default ActionHelper.generate({
  setPending: [actions.PENDING_SET, 'id'],
  resetPending: [actions.PENDING_RESET, 'id'],
});
